export const isMatchingUrl = (productUrl: string, value: string | null) =>
  productUrl === value || productUrl + '/' === value;
